// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3Ppmt","question":"styles_question__2tfRK","inputVisibleButton":"styles_inputVisibleButton__1fgNB","note":"styles_note__3Gni2"};